import { useState, useRef, useEffect } from 'react'
import { validateEmail } from '@/shared/utils';
import { Button, Spacing, HalfSpacing, Textbox, RadioGroup, RadioOption } from '@/form/FormComponents'
import { FormProvider, FormSubmitProvider } from '@/form/FormProvider'
import { SignInContainer } from '@/pages/SignedOutLayout'
import { useErrorModal, useModal, Modal, ModalContent} from '@/components/Modal';
import { Icon } from '@/components/Icon'
import { API_URL } from '@/data/loaders';

export function WaitlistLayout() {
  const [loading, setLoading] = useState(false);
  const [openErrorModal] = useErrorModal();

  const [openSubmittedModal] = useModal(({ closeModal }) => {
    return (
      <Modal width={330} confetti={true}>
        <ModalContent>
          <div className="assignment_submitted">
            <Icon name="check-circle"/>
            <div>You're on the waitlist!</div>
            <div>We'll reach out soon.</div>
          </div>
        </ModalContent>
      </Modal>
    )
  });

  const handleWaitlistSubmit = function({ formatted_data, focusError, updateData }) {
    let email = formatted_data.email;

    if (!validateEmail(email)) {
      focusError({name: "email", error: "Please enter a valid email address"})
      return;
    }

    setLoading(true);

    fetch(API_URL+"/submitWaitlistForm", {
      method: "post",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email,
        program_name: formatted_data.program_name || ""
      })
    }).then(function(response) {
      if (response.ok) {
        setLoading(false);
        openSubmittedModal();
        updateData({});
      } else {
        setLoading(false);
        openErrorModal();
      }
    }).catch(function(error) {
      console.error(error);
      setLoading(false);
      openErrorModal();
    })
  };

  return (
    <SignInContainer loading={loading}>
      <FormProvider onSubmit={handleWaitlistSubmit} obviated={loading}>
        <FormSubmitProvider>
          {({handleSubmit}) => (
            <>
              <div className="setup_title">Join the student waitlist</div>
              <div className="setup_description">Interested in early access to Sapient Clinician for students? Enter your email address below to join the waitlist.</div>
              <Spacing/>
              <HalfSpacing/>
              <Textbox name="email" required="Please enter your email" title="Email" autofocus={true} autoComplete="email" />
              <Spacing/>
              <Textbox name="program_name" title="Program name" />
              <Spacing/>
              <Spacing/>
              <div className="buttons right">
                <Button text="Join waitlist" className="primary" onClick={handleSubmit}/>
              </div>
            </>
          )}
        </FormSubmitProvider>
      </FormProvider>
    </SignInContainer>
  )
}